import { Table } from "@tanstack/react-table"
import { Button } from "@ui/button"

interface Props<T> {
    defaultPageSize?: number
    table: Table<T>
}

export function TFoot<T>({ defaultPageSize = 12, table }: Props<T>) {
    return (
        <tfoot>
            <tr>
                <td colSpan={100}>
                    <nav
                        className="flex items-center justify-between bg-white p-3 dark:bg-zinc-900"
                        aria-label="Pagination"
                    >
                        <div className="hidden sm:block">
                            <p className="text-sm text-gray-700 dark:text-gray-400">
                                Showing{" "}
                                <span className="font-medium">
                                    {table.getState().pagination.pageIndex * defaultPageSize + 1 >=
                                    table.getFilteredRowModel().rows.length
                                        ? table.getFilteredRowModel().rows.length
                                        : table.getState().pagination.pageIndex * defaultPageSize + 1}
                                </span>{" "}
                                to{" "}
                                <span className="font-medium">
                                    {(table.getState().pagination.pageIndex + 1) * defaultPageSize >=
                                    table.getFilteredRowModel().rows.length
                                        ? table.getFilteredRowModel().rows.length
                                        : (table.getState().pagination.pageIndex + 1) * defaultPageSize}
                                </span>{" "}
                                of <span className="font-medium">{table.getFilteredRowModel().rows.length}</span>{" "}
                                results
                            </p>
                        </div>
                        <div className="grid flex-none grid-cols-2 justify-between gap-x-4 sm:justify-end">
                            <Button onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>
                                Previous
                            </Button>
                            <Button onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
                                Next
                            </Button>
                        </div>
                    </nav>
                </td>
            </tr>
        </tfoot>
    )
}
